import { motion } from "framer-motion";
import { fadeUp } from "../utils/variants";
import { COLORS } from "../constants/colors";
import ERPModal from "./ERPModal";
import { useState, useEffect } from "react";
import SchoolInquiryModal from "./SchoolInquiryModal";

const HeroSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [quoteIndex, setQuoteIndex] = useState(0);

  const quotes = [
    "Educator",
    "Teacher",
    "Future Builder",
    "Innovator",
    "Mentor",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setQuoteIndex((prev) => (prev + 1) % quotes.length);
    }, 2000); // change every 3 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="flex flex-col md:flex-row items-center justify-between px-8 md:px-20 py-28"
      style={{ background: COLORS.gradientHero }}
    >
      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="visible"
        className="text-left max-w-lg space-y-6"
      >
        <h4 style={{ color: COLORS.primary }} className="font-semibold text-lg">
          A Product of Shri Satya Technologies
        </h4>

        <h1
          style={{ color: COLORS.textPrimary }}
          className="text-5xl font-bold leading-snug"
        >
          The Brain of an{" "}
          <span style={{ color: COLORS.primary }}>EdTech</span>.<br />
          The Soul of an{" "}
          <motion.span
            key={quoteIndex}
            style={{ color: COLORS.primary }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5 }}
          >
            {quotes[quoteIndex]}
          </motion.span>.
        </h1>

        <p style={{ color: COLORS.textSecondary }} className="text-lg">
          A cloud-based, AI-powered School ERP that simplifies everything —
          from admissions and attendance to finance and events.
        </p>

        <div className="flex flex-wrap gap-4 pt-2">
          <motion.button
            whileHover={{ scale: 1.05 }}
            style={{
              backgroundColor: COLORS.secondary,
              color: COLORS.textPrimary,
            }}
            onClick={() => setShowModal(true)}
            className="hover:bg-yellow-500 px-6 py-3 rounded-full font-semibold"
          >
            Get Quotation →
          </motion.button>
        </div>
      </motion.div>

      <motion.div
        variants={fadeUp}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.3 }}
        className="mt-12 md:mt-0 md:ml-12"
      >
        <img
          src="/assets/homepic.jpg"
          alt="School ERP"
          className="w-[90%] md:w-[500px] mx-auto drop-shadow-xl rounded-xl"
        />
      </motion.div>

      <SchoolInquiryModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </section>
  );
};

export default HeroSection;
